module.exports = __webpack_public_path__ + "static/media/aboutus.d40a4a9d.svg";